import { canvasFonted } from '../../fun-js-lib/canvas'
import { textWidth } from '../canvasDraw'
import { pageNumberRect } from './rects'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {number} pageNumber 
 */
export function textPageNumber (context, pageNumber) {
  let rect = pageNumberRect()
  let text = '' + pageNumber
  let x = rect.x + rect.w / 2 - textWidth(context, text) / 2
  let y = rect.y + 100
  canvasFonted(context, '44px Arial', () =>
    context.fillText(text, x, y))
}